import { getEvents } from '@app/analytics/models/helpers';
import { TagContainer } from '@app/analytics/models/container';
import { ClickOnHeaderButton } from '@app/core/header/store';

/**
 * When the user clicks on links on the header.
 */
const events = getEvents((action: ClickOnHeaderButton) => [
  {
    type: 'event',
    container: TagContainer.Analytics,
    payload: {
      event: 'headerClick',
      button_name: action.payload.button_name
    }
  }
]);

export default events;
